// Configuración del sitio con los valores por defecto que se compilan en el bundle.
//
// Estos valores son la fuente de verdad y garantizan que la home funcione aún si
// Firestore no responde o si las reglas bloquean la lectura. `SiteConfigContext`
// los sobreescribe con el documento `settings/home` de Firestore cuando existe,
// así se puede prender y apagar cada sección sin necesidad de un deploy.
//
// El estado actual es TEMPORAL: la edición 2026 se anuncia dentro del CESSI Summit,
// así que se ocultan las secciones que todavía no aplican (entradas, sponsors) y
// el hero apunta al sitio del Summit.
export const defaultSiteConfig = {
  // Visibilidad de las secciones de la home.
  home: {
    showTickets: false,
    showSponsorCta: false,
    showSponsors: false,
    showHistoryLink: false,
  },

  // Texto que se muestra sobre el video del hero.
  event: {
    date: "14 DE OCTUBRE",
    venue: "CENTRO DE CONVENCIONES BUENOS AIRES",
  },

  // Botón destacado del header.
  eventButton: {
    visible: true,
    label: "Evento 2026",
    url: "https://summit.cessi.org.ar/",
  },
};

// Video de fondo del hero. Es el fallback compilado en el bundle: la fuente de
// verdad es el campo `videoUrl` de la competición vigente, que se edita desde
// Administración > Competiciones.
export const DEFAULT_HOME_VIDEO_URL =
  "https://www.youtube.com/watch?v=o3ez6HjTvfs";

// Colección y documento de Firestore que sobreescriben los defaults de arriba.
export const SITE_CONFIG_COLLECTION = "settings";
export const SITE_CONFIG_DOCUMENT = "home";
